import { render, staticRenderFns } from "./CFileupload.vue?vue&type=template&id=72c01789&scoped=true"
import script from "./CFileupload.vue?vue&type=script&lang=ts"
export * from "./CFileupload.vue?vue&type=script&lang=ts"
import style0 from "./CFileupload.vue?vue&type=style&index=0&id=72c01789&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c01789",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
